/**
* Created For: 公用搜索条
* this.$emit("input",val)  this.$emit("enter",this.keyword)  this.$emit("blur",this.keyword)
* Author: xuRui.
* Date: 2019/12/30  15:30.
*/
<template>
  <div class="feedbackBox">
    <v-title title="电话、地址位置错误" :isShowBack="true" :isDefaultBack="false" @backHandle="goBack()"></v-title>
    <div class="closeBox">
      <cube-form :model="model" @validate="validateHandler" @submit="submitHandler">
        <cube-form-group>
          <ul class="formBox">
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/name.png') " alt="">
                <p class="title-p">药店名称</p>
              </div>
              <div>
                <cube-form-item :field="fields[0]"></cube-form-item>
              </div>

            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/location.png') " alt="">
                <p class="title-p">所在位置</p>
              </div>
              <div class="addressBOX" @click="goAddressChioce(detailData)">
                <!-- <div class="addressBOXTitle" v-if="$route.query.first && $route.query.first === true && $route.query.frash === true">
                                        点击编辑所在位置
                                    </div> -->
                <div class="addressMapEdit">
                  <p class="addressMapEditMark"></p>
                  <el-amap vid="amapDemo1" :center="[Number(detailData.longitude),Number(detailData.latitude)]" :zoom="16" class="amap-demo">
                    <el-amap-marker vid="component-marker" :position="[Number(detailData.longitude),Number(detailData.latitude)]" ></el-amap-marker>
                  </el-amap>
                </div>
                <!-- <img :src="require('@/assets/feedback/mapImg.png') " > -->
              </div>

            </li>

            <li>
              <div class="title">
                <img class="addressDrugstoreImg" :src="require('@/assets/feedback/address.png') " alt="">
                <p class="title-p">药店地址</p>
              </div>
              <div>
                <cube-form-item :field="fields[1]"></cube-form-item>
              </div>
            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/telephone.png') " alt="">
                <p class="title-p">联系电话</p>
              </div>
              <div>
                <cube-form-item :field="fields[2]"></cube-form-item>
              </div>
            </li>
            <li>
              <div class="title">
                <img :src="require('@/assets/feedback/photo.png') " alt="">
                <p class="title-p">现场照片</p>
              </div>
              <div>
                <div style="padding-left:40px">
                  <cube-upload
                    ref="upload"
                    v-model="files"
                    :max="3"
                    @files-added="filesAdded"
                    :process-file="processFile"
                  >
                  </cube-upload>
                </div>
                <!-- <cube-form-item :field="fields[3]"></cube-form-item> -->
                <span class="imgShow">
                  请提供药店门脸照片，以及营业执照照片，确保门脸牌匾和营业执照字体清晰可见。
                </span>
              </div>
            </li>
          </ul>
          <cube-form-group>
            <cube-button type="submit" :disabled="addsubmit">提交</cube-button>
          </cube-form-group>
        </cube-form-group>
      </cube-form>
    </div>
  </div>
</template>

<script>
import { addFeedBack } from '@/api/feedBack'
import compress from '@/utils/compress' // compress方法用的是鹅厂的，compress.js的完整代码在本文
export default {
  name: 'AddDetail',
  components: {},

  data () {
    const self = this
    return {
      addsubmit: false,
      value: '',
      imgObject: [],
      photoes: [],
      detailData: {},
      files: [],
      imgList: [],
      valid: undefined,
      validity: {},
      options: {
        scrollToInvalidField: true,
        layout: 'standard' // classic fresh
      },
      events: {

        init () {
          console.log('/////////////////////')
          console.log(self)

          // AMapUI.loadUI(['misc/PositionPicker'], function(PositionPicker) {

          //     var positionPicker = new PositionPicker({
          //         mode: 'dragMap',
          //         map: map
          //     });
          //     // 创建纯文本标记

          // });
        }
      },
      model: {
        clientId: '', // 终端ID
        clientType: '', // 终端类型
        description: '', // 问题描述
        latitude: '', // 纬度
        longitude: '', // 经度
        parentName: '', // 总部名称
        name: '', // 终端名
        phone: '', // 电话
        photoes: [], // 照片
        type: 2, // 类型
        address: '', // 地址
        uploadValue: []
      },
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          props: {
            placeholder: '',
            maxlength: 100
          },
          rules: {

          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'input',
          modelKey: 'address',
          props: {
            maxlength: 50,
            placeholder: ''
          },
          rules: {
            required: true
          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'input',
          modelKey: 'phone',
          props: {
            maxlength: 20,
            placeholder: ''

          },
          rules: {

          },
          // validating when blur
          trigger: 'blur'
        },
        {
          type: 'upload',
          simultaneousUploads: 3,
          modelKey: 'uploadValue',
          props: {
            // action: {
            //     target: 'https://upload.oonnnoo.com/upload',
            //     // fileName: 'upfile',
            //     // data: {
            //     //     token: 'token'
            //     // },
            //     checkSuccess: (res, file) => {
            //         console.log('res', file)
            //         let url = file.url
            //         self.imgObject.push({url:url,base:JSON.parse(JSON.stringify(self.imgList))[JSON.parse(JSON.stringify(self.imgList)).length-1]})
            //          self.$createToast({
            //             type: 'success',
            //             time: 1000,
            //             txt: '上传成功'
            //         }).show()
            //         return true
            //     }
            // },
            max: 3
          },
          events: {
            'files-added': (...args) => {
              self.toast = this.$createToast({
                txt: '正在上传。。。',
                time: 0,
                mask: false
              })
              self.toast.show()
              self.filesAdded(...args)
            },
            'file-removed': (...args) => {
              self.imgObject.forEach((item, index) => {
                if (item.url === args[0].url) {
                  self.imgObject.splice(index, 1)
                }
              })
            },
            'file-submitted': (...args) => {
              const url = args[0].url
              setTimeout(function () {
                self.toast.hide()
                self.imgObject.push({ url: url, base: JSON.parse(JSON.stringify(self.imgList))[JSON.parse(JSON.stringify(self.imgList)).length - 1] })
                self.$createToast({
                  type: 'success',
                  time: 800,
                  txt: '上传成功'
                }).show()
              }, 800)
            }
          },
          rules: {
            // uploaded: (val, config) => {
            //     return Promise.all(val.map((file, i) => {
            //     return new Promise((resolve, reject) => {
            //         if (file.uploadedUrl) {
            //         return resolve()
            //         }
            //         // fake request
            //         setTimeout(() => {
            //             if (i % 2) {
            //                 reject(new Error())
            //             } else {
            //                 file.uploadedUrl = 'uploaded/url'
            //                 resolve()
            //             }
            //         }, 1000)
            //     })
            //     })).then(() => {
            //         return true
            //     })
            // }
          },
          messages: {
            uploaded: '上传失败'
          }
        }
      ]
    }
  },
  computed: {},
  created () {
    this.detailData = JSON.parse(this.$route.query.data)
    this.model.name = this.detailData.clientName
    this.model.clientAddress = this.detailData.clientAddress
    this.model.phone = this.detailData.phone
    this.model.clientType = this.detailData.thirdType
    this.model.clientId = this.detailData.matchClientId
  },
  methods: {
    // 处理原始文件函数
    processFile (file, next) {
      // console.log("............")
      // console.log('file1:', file.base64) // 原图片
      compress(file, {
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.2
        }
      }, (file) => {
        // console.log('file2:', file.base64) // 压缩后的图片
        // console.log(this.files)
        next(file)
      })
    },
    filesAdded (files) {
      let hasIgnore = false
      // 最大5M
      const maxSize = 5 * 1024 * 1024// 最大上传范围

      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
          break
        }
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 800,
        txt: '上传图片过大'
      }).show()
    },
    // 压缩图片方法
    compressPic (bdata) {
      // 注意这里this作用域的问题
      const that = this
      that.model.photoes = bdata
      addFeedBack(that.model).then(res => {
        if (res.code === 1) {
          that.addsubmit = false
          that.toastsub.hide()
          that.$router.push({ name: 'feedbackSuccess' })
        } else {
          that.toastsub.hide()
          // this.$router.push({name:'addDetail',query:{data:JSON.stringify(this.detailData),frash:true}})
        }
      })
    },
    // goBack(){
    //     this.$router.push({name:"feedbackMessage"})
    // },

    submitHandler (e) {
      this.pushUserLog('提交反馈')
      if (this.addsubmit === true) {
        return
      }
      this.addsubmit = true
      // this.$router.push({name:"feedbackSuccess"})
      e.preventDefault()
      this.model.photoes = []
      this.photoes = []
      for (var i = 0; i < this.files.length; i++) {
        // this.compressPic(this.imgList[i])
        this.photoes.push(this.files[i].base64)
      }
      this.toastsub = this.$createToast({
        txt: '正在提交。。。',
        time: 0,
        mask: false
      }).show()
      this.compressPic(this.photoes)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
      console.log('validity', result.validity, result.valid, result.dirty, result.firstInvalidFieldIndex)
    },
    resetHandler (e) {
      console.log('reset', e)
    },
    // 选择地图
    goAddressChioce (data) {
      this.$router.push({ name: 'addressMap',
        query: {
          data: JSON.stringify(data)
        } })
    },
    pushUserLog (text) {
      // 上报操作日志
      this.$store.dispatch('PushUserLog', {
        menu: '终端地图',
        page: '终端地图',
        operation: text
      })
    }
  },
  activated () {
    if (this.$route.query.frash !== undefined) {
      if (this.$route.query.frash) {
        console.log('.....传来的值.......')
        console.log(this.detailData)
        this.detailData = JSON.parse(this.$route.query.data)
        console.log(this.detailData)
        this.model.name = this.detailData.clientName
        this.model.address = this.detailData.clientAddress
        this.model.phone = this.detailData.phone
        this.model.latitude = this.detailData.latitude
        this.model.longitude = this.detailData.longitude
        this.model.uploadValue = []
        this.files = []
        this.imgList = []
        this.imgObject = []
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../../stylus/base/base.styl"
    .feedbackBox{
        height 100%
        .closeBox{
            padding 32px
            padding-top 100px
            .formBox{

                li{

                    .title{
                        display flex
                        align-items  center
                        padding 20px 0
                        img{
                            width 30px
                            height 30px
                        }
                        .addressDrugstoreImg{
                            width 25px
                            height 30px
                        }
                        .title-p{
                            font-size 28px
                            margin-left 30px
                            color #333333
                        }
                    }
                }
            }
        }

        .cube-textarea{
            height auto
        }
        .addressBOX{
            height 200px
            padding 0 50px
            line-height 200px
            position relative
            .addressBOXTitle{
                width 100%
                height 100%
                color #fff
                text-align center
                background url('~@/assets/feedback/mapImg.png') 100% center
             }
            img{
                display block
                width 100%
                height 100%
            }
        }
        .imgShow{
            color #999999
            font-size 24px
            line-height 30px
            padding-left 60px
        }
        .cube-btn{
            background #5785ea
            border-radius 40px
            margin 50px 0
        }
        .cube-form-item{
            padding-left:60px
        }
        .addressMapEdit{
            height 100%
            position relative
            .addressMapEditMark{
                position absolute
                width 100%
                height 100%
                z-index 2
            }
        }
    }
</style>
